
import React, { useRef, useState } from "react";
import { Carousel, Container, Row, Col } from "react-bootstrap";
import { useType } from "./hooks/useType";
import { FaHandHoldingMedical } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const TypePage = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const navigate = useNavigate();

    const { productsSearchType } = useType();

    const handleCardClick = (category) => {
        navigate(`/type-service/${category}`);
    };

    const carouselRef = useRef(null);
    let holdTimer = null;

    const handleMouseDown = () => {
        holdTimer = setInterval(() => {
            if (carouselRef.current) {
                carouselRef.current.next(); // Move to next slide
            }
        }, 700); // Change slide every 700ms while holding
    };

    const handleMouseUp = () => {
        clearInterval(holdTimer);
    };

    // Merge hover and stop hold-click behavior
    const handleMouseLeave = (e) => {
        handleMouseUp(); // Stop carousel auto-scroll
        e.currentTarget.style.transform = "scale(1)"; // Reset scaling
        setHoveredIndex(null);
    };

    const handleMouseEnter = (index) => {
        setHoveredIndex(index); // Set the index of the item being hovered
    };

    return (

        <Container className="mt-5">
            <Row className="align-items-center">
                {/* Left Section: Modern Gradient Overlay */}
                <Col
                    md={6}
                    className="text-white text-center text-md-start position-relative d-flex align-items-center justify-content-center"
                    style={{
                        backgroundImage: "url('/17818.jpg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "0px",
                        minHeight: "300px",
                        position: "relative",
                        padding: "40px",
                        overflow: "hidden",
                        maskImage: "linear-gradient(to left, rgba(0,0,0,0) 1%, rgba(0,0,0,1) 20%)",
                        WebkitMaskImage: "linear-gradient(to left, rgba(0,0,0,0) 1%, rgba(0,0,0,1) 20%)"
                    }}
                >
                    {/* Blur Effect - Positioned Absolutely */}
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: "100%", // Right side affected
                            height: "100%",
                            background: "linear-gradient(to right, rgba(255,255,255,0) 20%, rgba(255,255,255,1) 100%)", // Smooth fade effect
                            backdropFilter: "blur(5px)", // Blurred background
                            WebkitBackdropFilter: "blur(5px)", // Safari support
                            zIndex: 1,
                        }}
                    ></div>

                    {/* Text Content - Above Blur Layer */}
                    <div style={{ zIndex: 2, position: "relative", textAlign: "left" }}>
                        <h4 style={{ color: 'green', fontWeight: "400", marginBottom: "10px" }}>Layanan Medis Yarsi</h4>
                        <h2 style={{ color: 'black', fontWeight: "700" }}>Solusi Kesehatan yang Menyeluruh</h2>
                        <p style={{ color: 'black', opacity: 0.9 }}>
                            Kami menyediakan layanan medis terbaik dengan berbagai pemeriksaan kesehatan yang lengkap.
                        </p>
                    </div>
                </Col>


                {/* Right Section: Improved Carousel */}
                <Col xs={12} md={6} className="d-flex justify-content-center">
                    <Carousel
                        indicators={false}
                        controls={true}
                        interval={3000}
                        style={{
                            width: "90%",
                            maxWidth: "400px",
                        }}
                    >
                        {productsSearchType.map((type, index) => (
                            <Carousel.Item key={index}>
                                <div
                                    onClick={() => handleCardClick(type.typeProductString)}
                                    onMouseDown={handleMouseDown}
                                    onMouseUp={handleMouseUp}
                                    onMouseEnter={() => handleMouseEnter(index)} // Set hovered item
                                    onMouseLeave={handleMouseLeave} // Reset hover when mouse leaves
                                    className="d-flex flex-column align-items-center justify-content-center"
                                    style={{
                                        padding: "30px",
                                        cursor: "pointer",
                                        transition: "transform 0.3s ease-in-out, border 0.3s ease-in-out",
                                        borderRadius: "8px",
                                        border: hoveredIndex === index ? "2px solid #348450" : "2px solid transparent", // Border on hover
                                        transform: hoveredIndex === index ? "scale(1.1)" : "scale(1)", // Scale on hover
                                    }}
                                >
                                    {/* Icon */}
                                    <div
                                        style={{
                                            fontSize: "50px",
                                            color: hoveredIndex === index ? "#348450" : "#8d070e", // Change icon color on hover
                                            marginBottom: "10px",
                                            transition: "color 0.3s ease-in-out",
                                        }}
                                    >
                                        {type.icon ? type.icon : <FaHandHoldingMedical />}
                                    </div>

                                    {/* Title */}
                                    <p
                                        style={{
                                            fontSize: "18px",
                                            fontWeight: "500",
                                            color: hoveredIndex === index ? "#348450" : "#8d070e", // Change title color on hover
                                            margin: "5px 0",
                                            transition: "color 0.3s ease-in-out",
                                        }}
                                    >
                                        {type.typeProductString}
                                    </p>

                                    {/* Count */}
                                    <h3
                                        style={{
                                            fontSize: "30px",
                                            fontWeight: "bold",
                                            color: hoveredIndex === index ? "#348450" : "#8d070e", // Change color on hover
                                            transition: "color 0.3s ease-in-out", // Smooth transition for color change
                                        }}
                                    >
                                        {type.count}
                                    </h3>
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </Col>
            </Row>
        </Container>

    );
};

export default TypePage;